(function () {
  'use strict';

  // Only activate on fine-pointer devices (desktops with mouse), not in Theme Editor
  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (window.Shopify && Shopify.designMode) return;

  // ── Inject CSS ────────────────────────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    body { cursor: none; }

    .cursor-dot {
      position: fixed;
      pointer-events: none;
      z-index: 9999;
      width: 8px;
      height: 8px;
      background: var(--color-bronze, #B89968);
      border-radius: 50%;
      transform: translate(-50%, -50%);
      transition: opacity 0.3s;
    }

    .cursor-ring {
      position: fixed;
      pointer-events: none;
      z-index: 9998;
      width: 32px;
      height: 32px;
      border: 1.5px solid var(--color-bronze, #B89968);
      border-radius: 50%;
      transform: translate(-50%, -50%);
      transition: width 0.2s var(--ease-out, ease-out),
                  height 0.2s var(--ease-out, ease-out),
                  opacity 0.3s,
                  background 0.2s;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

    .cursor-ring.is-expanded {
      width: 64px;
      height: 64px;
    }

    .cursor-ring.is-image {
      width: 64px;
      height: 64px;
      background: rgba(184, 153, 104, 0.12);
    }

    .cursor-ring__label {
      font-family: var(--font-sans, Inter, sans-serif);
      font-size: 10px;
      letter-spacing: 0.08em;
      color: var(--color-bronze, #B89968);
      opacity: 0;
      transition: opacity 0.2s;
      text-transform: uppercase;
      white-space: nowrap;
      position: absolute;
    }

    .cursor-ring.is-image .cursor-ring__label {
      opacity: 1;
    }
  `;
  document.head.appendChild(style);

  // ── Create DOM elements ───────────────────────────────────────────────────
  const dot = document.createElement('div');
  dot.className = 'cursor-dot';

  const ring = document.createElement('div');
  ring.className = 'cursor-ring';

  const label = document.createElement('span');
  label.className = 'cursor-ring__label';
  label.textContent = 'Voir';
  ring.appendChild(label);

  document.body.appendChild(dot);
  document.body.appendChild(ring);

  // ── State ─────────────────────────────────────────────────────────────────
  let mouseX = -100;
  let mouseY = -100;
  let ringX = -100;
  let ringY = -100;
  const LERP = 0.15;

  // ── Mouse position tracking ───────────────────────────────────────────────
  document.addEventListener('mousemove', function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  // Hide when mouse leaves viewport
  document.addEventListener('mouseleave', function () {
    dot.style.opacity = '0';
    ring.style.opacity = '0';
  });

  document.addEventListener('mouseenter', function () {
    dot.style.opacity = '1';
    ring.style.opacity = '1';
  });

  // ── Hover state management ────────────────────────────────────────────────
  const magneticSelectors = 'a, button, .category-item, .product-card';
  const imageSelectors = 'img';

  document.addEventListener('mouseover', function (e) {
    const target = e.target;

    if (target.closest(magneticSelectors)) {
      ring.classList.add('is-expanded');
    }

    if (target.tagName === 'IMG' || target.closest('figure')) {
      ring.classList.add('is-image');
    }
  });

  document.addEventListener('mouseout', function (e) {
    const target = e.target;

    if (target.closest(magneticSelectors)) {
      ring.classList.remove('is-expanded');
    }

    if (target.tagName === 'IMG' || target.closest('figure')) {
      ring.classList.remove('is-image');
    }
  });

  // ── Animation loop ────────────────────────────────────────────────────────
  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function tick() {
    // Dot follows exactly
    dot.style.left = mouseX + 'px';
    dot.style.top = mouseY + 'px';

    // Ring follows with lag
    ringX = lerp(ringX, mouseX, LERP);
    ringY = lerp(ringY, mouseY, LERP);
    ring.style.left = Math.round(ringX * 10) / 10 + 'px';
    ring.style.top = Math.round(ringY * 10) / 10 + 'px';

    requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
})();
